import { IEngineSection, Widget } from '@framework/engine';
import React from 'react';
import { FillableForm } from '../section/FillableForm';

export interface ISectionsFillableFormProps {
  sections: IEngineSection[];
  readonly: boolean;
  /** Permette di gestire dinamicamente il readonly per ogni singolo widget */
  isReadonly?: (widget: Widget) => boolean;
}

/**
 * Componente in cui richiamiamo `FillableForm` al cui interno interroghiamo
 * il context `ModuleFormSectionsMonitorContext` tramite `useModuleFormSectionRuntime`
 * per sapere puntualmente se una sezione è visibile o meno gestendo correttamente
 * tutti i widget compresi quelli grafici.
 */
export function SectionsFillableForm(props: ISectionsFillableFormProps) {
  const { sections, readonly } = props;

  return (
    <>
      {sections.map(runtimeSection => {
        return (
          <FillableForm
            section={runtimeSection}
            readonly={readonly}
            isReadonly={props.isReadonly}
            key={runtimeSection.id}
          />
        );
      })}
    </>
  );
}
